<template>
  <page-template >
    <template slot="page-content">
      <div class="take-a-stand--template page-template bg-beige pb5">
        <div class="db relative pt4 pb5 pt5-ns pb6-ns z-content">
          <div class="relative container-fluid mw9 center">
            <section class="relative mw8 center">
              <h1 class="mv0 ttu f-page-title-take is-blenny is-navy mt4 mt0-m mt0-l is-navy">{{ page.title }}</h1>
            </section>
            <section class="db relative center mw8" :id="page.intro_section.id" v-if="page.intro_section && page.intro_section.is_published">
              <h2 class="mt5 tc ttu f2 is-lorano-bold is-green" v-if="page.intro_section.header">{{page.intro_section.title}}</h2>
              <div class="relative mt4 f3 lh-copy tl is-tablet-semicond-bold is-navy cms-content" v-html="marked(page.intro_section.text)"></div>
            </section>
            <section class="db relative center mw8 pt5 pt6-ns" :id="page.act_section.id" v-if="page.act_section && page.act_section.is_published">
              <h2 class="tl ttu f1 is-lorano-bold is-navy" v-if="page.act_section.title">{{page.act_section.title}}</h2>
              <ul class="mt4 pl0">
                <li class="" v-for="(item, index) in page.act_section.links" :key="'act-link-' + index">
                  <a class="db relative mv3 f3 f3-ns underline" :href="item.link" target="_blank" :title="item.title">{{ item.title }}</a>
                </li>
              </ul>
            </section>
            <section class="db relative center mw8 pt5 pt6-ns" :id="page.get_involved_section.id" v-if="page.get_involved_section && page.get_involved_section.is_published">
              <h2 class="tl ttu f1 is-lorano-bold is-navy">{{page.get_involved_section.title}}</h2>
              <h3 class="mt4 mt5-ns tl ttu f3 f2-ns is-lorano-bold is-navy" v-if="page.get_involved_section.justice_subtitle">{{page.get_involved_section.justice_subtitle}}</h3>
              <div class="row mt3 mh0">
                <div class="col-xs-12 col-sm-6 mv3 ph0 pr4-ns" v-for="(item, index) in page.get_involved_section.justice_orgs" :key="'org-item-' + index">
                  <a class="pointer org-link" :href="item.link" :title="item.title" target="_blank"><h4 class="mt4 tl ttu f3 is-tablet-bold is-navy">{{item.title}}</h4></a>
                  <p class="mt3 f4 lh-copy cms-content">{{ item.text | truncate(160,'...') }} <a class="pointer b" @click="openModalComponent(item.title, item.text)" title="Read More">Read More</a></p> 
                  <a class="db mw5 mt3 btn-generic has-red-bg" :href="item.support" target="_blank" title="Support">
                    <span class="text">
                      Support
                    </span>
                  </a>
                </div>
              </div>
              <h3 class="mt5 tl ttu f3 f2-ns is-lorano-bold is-navy" v-if="page.get_involved_section.bay_area_subtitle">{{page.get_involved_section.bay_area_subtitle}}</h3>
              <div class="row mt3 mh0">
                <div class="col-xs-12 col-sm-6 mv3 ph0 pr4-ns" v-for="(item, index) in page.get_involved_section.bay_area_orgs" :key="'org-item-' + index">
                  <a class="pointer org-link" :href="item.link" :title="item.title" target="_blank"><h4 class="mt4 tl ttu f3 is-tablet-bold is-navy">{{item.title}}</h4></a>
                  <p class="mt3 f4 lh-copy cms-content">{{ item.text | truncate(160,'...') }} <a class="pointer b" @click="openModalComponent(item.title, item.text)" title="Read More">Read More</a></p> 
                  <a class="db mw5 mt3 btn-generic has-red-bg" :href="item.support" target="_blank" title="Support">
                    <span class="text">
                      Support
                    </span>
                  </a>
                </div>
              </div>
              <h3 class="mt5 tl ttu f3 f2-ns is-lorano-bold is-navy" v-if="page.get_involved_section.national_subtitle">{{page.get_involved_section.national_subtitle}}</h3>
              <div class="row mt3 mh0">
                <div class="col-xs-12 col-sm-6 mv3 ph0 pr4-ns" v-for="(item, index) in page.get_involved_section.national_orgs" :key="'org-item-' + index">
                  <a class="pointer org-link" :href="item.link" :title="item.title" target="_blank"><h4 class="mt4 tl ttu f3 is-tablet-bold is-navy">{{item.title}}</h4></a>
                  <p class="mt3 f4 lh-copy cms-content">{{ item.text | truncate(160,'...') }} <a class="pointer b" @click="openModalComponent(item.title, item.text)" title="Read More">Read More</a></p> 
                  <a class="db mw5 mt3 btn-generic has-red-bg" :href="item.support" target="_blank" title="Support">
                    <span class="text">
                      Support
                    </span>
                  </a>
                </div>
              </div>
            </section>
            <section class="db relative center mw8 pt5 pt6-ns" :id="page.follow_section.id" v-if="page.follow_section && page.follow_section.is_published">
              <h2 class="tl ttu f1 is-lorano-bold is-navy">{{page.follow_section.title}}</h2>
              <h3 class="mt4 tl ttu f3 is-lorano-bold is-navy" v-if="page.follow_section.subtitle">{{page.follow_section.subtitle}}</h3>
              <div class="row mt3 mh0">
                <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 mv3 ph2 pr4-ns" v-for="(item, index) in page.follow_section.orgs" :key="'org-item-' + index">
                  <a class="db relative org-hdr-link grow" :href="item.link" :title="item.title" target="_blank">
                    <img class="db relative mt3 w-100 mw-100" v-lazy="item.image" :alt="item.title" />
                    <h3 class="mt4 tl ttu f3 is-tablet-bold is-navy">{{item.title}}</h3>
                  </a>
                </div>
              </div>
            </section>
            <section class="db relative center mw8 pt5 pt6-ns" :id="page.support_section.id" v-if="page.support_section && page.support_section.is_published">
              <h2 class="tl ttu f1 is-lorano-bold is-navy" v-if="page.support_section.title">{{page.support_section.title}}</h2>
              <div class="row">
                <div class="col-xs-12 col-sm-6">
                  <h3 class="mt5 tl ttu f3 is-lorano-bold is-navy">{{page.support_section.restaurants_subtitle}}</h3>
                  <ul class="mt4 pl0">
                    <li class="" v-for="(item, index) in page.support_section.restaurants" :key="'act-link-' + index">
                      <a class="db relative mv3 f3 underline" :href="item.link" target="_blank" :title="item.title">{{ item.title }}</a>
                    </li>
                  </ul>
                </div>
                <div class="col-xs-12 col-sm-6">
                  <h3 class="mt5 tl ttu f3 is-lorano-bold is-navy" v-if="page.support_section.businesses_subtitle">{{page.support_section.businesses_subtitle}}</h3>
                  <ul class="mt4 pl0">
                    <li class="" v-for="(item, index) in page.support_section.businesses" :key="'act-link-' + index">
                      <a class="db relative mv3 f3 underline" :href="item.link" target="_blank" :title="item.title">{{ item.title }}</a>
                    </li>
                  </ul>
                </div>
                <div class="mt4 f4 is-navy cms-content" v-if="page.end_text" v-html="marked(page.end_text)"></div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from './page-template.vue'
import TextModal from './text-modal.vue'
export default {
  components: {
    PageTemplate,
    TextModal
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      bgOpaciy: 0,
      bgScrollStart: this.$bgScrollStart,
      scrollPos: 0,
      parallax:null,
      parallax2:true,
      window: {
        width: 0,
        height: 0
      },
      isWindowWidthMobile: null,
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName(this.pageMarkdownFileName);
      return pageData[0];
    }
  },
  methods : {
    sizing: function(){
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768)
        this.isWindowWidthMobile = true; 
      else{
        this.isWindowWidthMobile = false; 
        this.mobileActive = -1;
      }
    },
    openModalComponent: function(title, text) {
      this.$modal.show(TextModal, 
          {
            title: title,
            text: text,
          }, 
          {
            height: 'auto',
            classes: 'cf-modal',
            adaptive: true,
            reset: true,
            scrollable: true,
            width: '75%',
            maxWidth: 768,
          },
          {
          'before-open': (event) => { 
            console.log('1.0 - this will be called before the modal opens'); 
          }
          },
          {
          'before-close': (event) => { 
            console.log('2.0 - this will be called before the modal closes'); }
          }
        );
    }
  },
  created() {
    var w = window.innerWidth;
    if (w < 768) {
      this.isWindowWidthMobile = true; 
    }
    else {
      this.isWindowWidthMobile = false; 
    }
    window.addEventListener('resize', this.sizing);
    //window.addEventListener('scroll', this.scrollBg);
    window.addEventListener('load', this.sizing);
  },
  mounted() {
    this.$nextTick(() => {
      //
    })

  },
  destroyed() {
    window.removeEventListener('resize', this.sizing);
    //window.removeEventListener('scroll', this.scrollBg);
    window.removeEventListener('load', this.sizing);
  }
}
</script>
